module.exports = __webpack_public_path__ + "static/media/info.4e509c4d.svg";